export const AUTH_BIZ_OPTIONS = [
  { label: "VIP", value: 1 },
  { label: "现场抽奖", value: 2 },
  { label: "管理员坐席", value: 3 },
  { label: "员工坐席", value: 4 },
];

export const STAFF_TYPE_OPTIONS = [
  { label: "管理员", value: "admin" },
  { label: "普通员工", value: "staff" },
];

export function getDurationOptions(bizType) {
  if (bizType === 1) {
    return [
      { label: "一周", value: 1 },
      { label: "1个月", value: 2 },
      { label: "3个月", value: 3 },
      { label: "一年", value: 4 },
    ];
  }

  if (bizType === 2) {
    return [
      { label: "1天", value: 1 },
      { label: "3天", value: 2 },
      { label: "10天", value: 3 },
    ];
  }

  if (bizType === 3 || bizType === 4) {
    return Array.from({ length: 12 }, (_, index) => ({
      label: `${index + 1}个月`,
      value: index + 1,
    }));
  }

  return [];
}

export function isPositiveInteger(value) {
  return /^[1-9]\d*$/.test(String(value));
}

export function toUnixSeconds(value) {
  if (!value) return undefined;
  return Math.floor(new Date(value).getTime() / 1000);
}

export function buildEditAuthRequest(uid, form) {
  const request = {
    uid,
    type: form.editType,
  };

  if (form.editType === "add") {
    request.duration = form.duration;
    request.order_no = String(form.orderNo || "").replace(/\s/g, "");
    request.biz_type = form.bizType;
    request.amount = Number(form.amount || 0);

    if (form.bizType === 3 || form.bizType === 4) {
      request.count = Number(form.count);
    }

    return request;
  }

  request.biz_type = 5;
  request.expire = toUnixSeconds(form.reduceTime);
  return request;
}

export function buildEditStaffRequest(uid, form) {
  return {
    uid,
    type: form.editStaffType,
    stype: form.staffType,
    count: Number(form.staffCount),
  };
}

export function buildUpdateStaffRequest(form) {
  return {
    id: form.id,
    count: Number(form.count),
    expire: toUnixSeconds(form.expire),
  };
}

export function isReduceExpireDateDisabled() {
  return false;
}

export function formatUnixTime(seconds, fallback = "-") {
  if (!seconds) return fallback;
  const date = new Date(seconds * 1000);
  if (Number.isNaN(date.getTime())) return fallback;
  const pad = (value) => String(value).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}
